import { render, staticRenderFns } from "./BookingSplitDetailPop.vue?vue&type=template&id=21e172fe"
import script from "./BookingSplitDetailPop.vue?vue&type=script&lang=js"
export * from "./BookingSplitDetailPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e172fe')) {
      api.createRecord('21e172fe', component.options)
    } else {
      api.reload('21e172fe', component.options)
    }
    module.hot.accept("./BookingSplitDetailPop.vue?vue&type=template&id=21e172fe", function () {
      api.rerender('21e172fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BookingSplitDetailPop.vue"
export default component.exports